export const API_KEY = '3252b55757f82a7afebb298a6a575a67'
export const API_BASE_URL = 'https://api.themoviedb.org/3'
export const IMAGE_PATH = "https://image.tmdb.org/t/p/original"